import { useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFiltersRegistry } from "../../../../../../context/FiltersProvider";
import {
	RootCauseListPayload,
	RootCauseWidgetModalShiftDTO,
} from "../../../../../../datasources/api-client/data-contracts";
import { ApiRoutes } from "../../../../../../datasources/networking/apiRoutes";
import { useReadResource } from "../../../../../../hooks/useResource";
import { CardDelta } from "../../components/CardDelta";
import ModalShiftBarChart from "./ModalShiftBarChart";
import ModalShiftDeltaBarChart from "./ModalShiftDeltaBarChart";

type ModalShiftProps = {
	onWarningsChange?: (warnings?: string[]) => void;
};

export const ModalShift = ({ onWarningsChange }: ModalShiftProps) => {
	const { rootCauseState } = useFiltersRegistry();
	const { t } = useTranslation("dataInsights.rootcause");

	const { data, isLoading } = useReadResource<RootCauseListPayload, RootCauseWidgetModalShiftDTO>(
		{
			route: ApiRoutes.RootCauseWidjetModalShift,
		},
		{
			readMethod: "post",
		},
		{ ...rootCauseState.payload }
	);

	useEffect(() => {
		onWarningsChange?.(data?.warnings ?? []);
	}, [data?.warnings]);

	return (
		<Stack gap={2}>
			<Typography variant="body2">{t("root cause results/modal shift sub")}</Typography>

			<Stack direction={"row"} spacing={2}>
				<CardDelta
					title={t("root cause results/modal shift/delta card title")}
					value={data?.co2Delta.value ?? -0}
					measure={data?.co2Delta.measure ?? "-"}
					isLoading={isLoading}
				/>
			</Stack>

			<ModalShiftBarChart
				title={t("root cause results/modal shift/transport mode shift title")}
				data={data?.items ?? []}
				baselineLabel={t("root cause results/modal shift/baseline")}
				comparisonLabel={t("root cause results/modal shift/comparison")}
				measure={t("root cause results/modal shift/tkm axis label")}
				isLoading={isLoading}
			/>

			<ModalShiftDeltaBarChart
				title={t("root cause results/modal shift/emissions delta title")}
				data={data?.items ?? []}
				increaseLabel={t("root cause results/modal shift/increase")}
				decreaseLabel={t("root cause results/modal shift/decrease")}
				measure={t("root cause results/modal shift/emissions delta axis label")}
				isLoading={isLoading}
			/>
		</Stack>
	);
};
